<template>
  <section id="Shop" class="g_section">
    <div class="g_bg_text opposite">
      <KinesisScroll
        tag="img"
        :src="'./static/hd_shop.svg'"
        :strength="100"
        type="translate"
        axis="y"
      />
    </div>
    <div class="g_hd_en_wrap">
      <FxText>
        <p class="g_hd_en">SHOP LIST</p>
      </FxText>
    </div>
    <div class="g_hd_ja_wrap">
      <FxText>
        <h2 class="g_hd_ja">ショップ</h2>
      </FxText>
    </div>
    <div class="content_body">
      <div class="shop_item">
        <div class="shop_window">
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_polygonstand/"
            target="_blank"
          >
            <img src="../../assets/img_shop1.png" alt="" />
          </a>
          <p>
            場所：ナーサリーライム<br
              class="g_ui_md"
            />けだるげなティーパーティー
          </p>
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_polygonstand/"
            target="_blank"
            class="g_link_button"
            >商品一覧はコチラ</a
          >
        </div>
      </div>
      <div class="shop_item">
        <div class="shop_window">
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_singyuradining/"
            target="_blank"
          >
            <img src="../../assets/img_shop2.png" alt="" />
          </a>
          <p>
            場所：ナーサリーライム<br
              class="g_ui_md"
            />けだるげなティーパーティー
          </p>
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_singyuradining/"
            target="_blank"
            class="g_link_button"
            >商品一覧はコチラ</a
          >
        </div>
      </div>
      <div class="shop_item">
        <div class="shop_window">
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_effectate/"
            target="_blank"
            ><img src="../../assets/img_shop3.png" alt=""
          /></a>
          <p>
            場所：ワールドエンドユートピア<br class="g_ui_md" />苔むした記念碑
          </p>
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_effectate/"
            target="_blank"
            class="g_link_button"
            >商品一覧はコチラ</a
          >
        </div>
      </div>
      <div class="shop_item">
        <div class="shop_window">
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_kellelenses/"
            target="_blank"
            ><img src="../../assets/img_shop4.png" alt=""
          /></a>
          <p>場所：ナーサリーライム<br class="g_ui_md" />やっかみキノコの森</p>
          <a
            href="https://virtualcast.jp/blog/2020/04/vm4_kellelenses/"
            target="_blank"
            class="g_link_button"
            >商品一覧はコチラ</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FxText from "../atoms/FxText";
import { KinesisScroll } from "vue-kinesis";
export default {
  name: "Shop",
  components: { KinesisScroll, FxText }
};
</script>

<style scoped>
.content_body {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.shop_item {
  margin: 0 0 30px;
}
.shop_window {
  border: 1px solid #fff;
  box-sizing: border-box;
  text-align: center;
  background: rgba(3, 1, 116, 0.2);
}
.shop_window p {
  font-weight: 900;
  margin: 1rem 0 0.6rem;
  line-height: 1.2;
  font-size: 1.1rem;
  font-feature-settings: "palt";
}
.g_link_button {
  margin: 0 2rem 1.5rem;
}
@media screen and (max-width: 1110px) {
  .shop_item {
    width: 49%;
  }
  .shop_window img {
    width: 100%;
  }
}
@media screen and (max-width: 578px) {
  .shop_item {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheShopSection.vue